import { takeLatest, call, put } from 'redux-saga/effects'
import certificatesList from 'api/administration/certificates/List'
import * as fromActions from 'store/actions/certificates.action'

async function getList(params) {
  return await certificatesList(params)
}

function* certificateListEffectSaga({ payload }: any) {
  try {
    const { data } = yield call(getList, payload)
    yield put(fromActions.Actions.certificateAdministrationListSuccess(data))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* certificateListWatcherSaga() {
  yield takeLatest(
    fromActions.CERTIFICATES_ADMINISTRATION_LIST,
    certificateListEffectSaga
  )
}
